import { userDetailsTransformer } from "./userDetailsTransformer"

export default {
  userDetailsTransformer,
}
